export default __webpack_public_path__ + "static/cop-edca0a96d1e6ade334d3372fbf65f66f.png";